import { memo } from "react";
import type { SelectedBboxRectProps } from "./types";

const rgbToCss = (rgb: [number, number, number]): string =>
  `rgb(${rgb[0]},${rgb[1]},${rgb[2]})`;

export const SelectedBboxRect = memo(function SelectedBboxRect({
  selectedObject,
  inflatePdf,
  strokeWidth,
  fillOpacity,
}: SelectedBboxRectProps) {
  const { bbox } = selectedObject;
  const x = bbox.x1 - inflatePdf;
  const y = bbox.y1 - inflatePdf;
  const width = bbox.x2 - bbox.x1 + 2 * inflatePdf;
  const height = bbox.y2 - bbox.y1 + 2 * inflatePdf;
  const groupColor = rgbToCss(selectedObject.rgb);
  const centerX = x + width / 2;
  const centerY = y + height / 2;
  // Half the diagonal so the ring clears the bbox corners, plus a gap of one stroke.
  const ringRadius = Math.hypot(width, height) / 2 + strokeWidth;

  return (
    <g>
      <circle
        className="bbox-selected-ring"
        cx={centerX}
        cy={centerY}
        r={ringRadius}
        fill="none"
        stroke="#000000"
        strokeWidth={strokeWidth}
      />
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={groupColor}
        opacity={fillOpacity}
      />
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill="none"
        stroke={groupColor}
        strokeWidth={strokeWidth}
      />
    </g>
  );
});
